export default __webpack_public_path__ + "static/media/Fittings.7eedeeb6.jpg";